import CircularProgress from "@/components/progress/circular-progress"
import { Button } from "@/components/ui/button"
import { X as XIcon } from "lucide-react"
import { useNavigate } from "react-router-dom"

interface SpecialDeckCheckpointModalProps {
  showCheckpointModal: boolean
  onClick: () => void
  confidenceLevels: number[]
  availableCardsQuantity: number
  totalAmountOfCards: number
}

export default function SpecialDeckCheckpointModal({
  showCheckpointModal,
  onClick,
  confidenceLevels,
  availableCardsQuantity,
  totalAmountOfCards,
}: SpecialDeckCheckpointModalProps) {
  const navigate = useNavigate()

  const handleOnClose = () => {
    navigate("/flashcards")
  }

  const sumOfTheLast10DeckCards = confidenceLevels
    .slice(-10)
    .reduce((acc, confidenceLevel) => acc + confidenceLevel, 0)

  const confidenceLevel = (sumOfTheLast10DeckCards / 50) * 100

  return showCheckpointModal ? (
    <div className="fixed left-0 top-0 z-20 size-full overflow-hidden bg-white">
      <div className="flex w-full shrink-0 items-center justify-end p-5">
        <button type="button" className="shrink-0 text-gray-500" onClick={handleOnClose}>
          <XIcon />
        </button>
      </div>

      <div className="flex size-full flex-col items-center justify-center gap-1 pb-[200px] md:h-auto md:justify-start md:pb-14 md:pt-10">
        {availableCardsQuantity !== 0 ? (
          <p className="text-center text-lg font-semibold">Índice de confianza actual</p>
        ) : (
          <div className="text-center">
            <p className="text-[28px] font-bold text-orange-500">¡Completaste la sesión!</p>
            <p className="text-lg">Revisaste {totalAmountOfCards} cartas.</p>
          </div>
        )}
        <div className="flex h-auto max-h-[300px] w-full max-w-[300px] overflow-hidden">
          <CircularProgress progress={Math.trunc(confidenceLevel)} className="h-full w-full" />
        </div>
        {availableCardsQuantity === 0 ? (
          <div className="mt-10 text-center">
            <p className="text-lg font-normal text-gray-500">¡Te esperamos mañana!</p>
            <p className="text-lg font-semibold text-gray-500">
              Este mazo se actualiza todos los días.
            </p>
          </div>
        ) : null}
      </div>

      <div className="fixed bottom-0 left-0 z-10 mx-auto w-full max-w-[800px] bg-white p-4 md:static md:p-3 md:text-center">
        <Button
          className="w-full rounded-[8px] bg-orange-500 p-3 text-[14px] font-bold text-white transition duration-200 hover:bg-orange-600 disabled:bg-neutral-200 disabled:text-neutral-500 md:max-w-[300px]"
          onClick={onClick}
        >
          {availableCardsQuantity !== 0
            ? `¿${availableCardsQuantity} ${availableCardsQuantity === 1 ? "carta" : "cartas"} más?`
            : "Continuar estudiando"}
        </Button>
      </div>
    </div>
  ) : null
}
